export const awsNetworkPaths = {
  securityGroups: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/security-groups`,
  securityGroupDetail: (connectionId, region, groupId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/security-groups/${encodeURIComponent(region)}/${encodeURIComponent(groupId)}`,
  vpcs: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/vpcs`,
  vpcDetail: (connectionId, region, vpcId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/vpcs/${encodeURIComponent(region)}/${encodeURIComponent(vpcId)}`,
  subnets: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/subnets`,
  subnetDetail: (connectionId, region, subnetId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/subnets/${encodeURIComponent(region)}/${encodeURIComponent(subnetId)}`,
  routeTables: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/route-tables`,
  routeTableDetail: (connectionId, region, routeTableId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/route-tables/${encodeURIComponent(region)}/${encodeURIComponent(routeTableId)}`,
  internetGateways: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/internet-gateways`,
  internetGatewayDetail: (connectionId, region, internetGatewayId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/internet-gateways/${encodeURIComponent(region)}/${encodeURIComponent(internetGatewayId)}`,
  natGateways: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/nat-gateways`,
  natGatewayDetail: (connectionId, region, natGatewayId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/nat-gateways/${encodeURIComponent(region)}/${encodeURIComponent(natGatewayId)}`,
  networkAcls: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/network-acls`,
  networkAclDetail: (connectionId, region, networkAclId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/network-acls/${encodeURIComponent(region)}/${encodeURIComponent(networkAclId)}`,
  vpcEndpoints: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/vpc-endpoints`,
  vpcEndpointDetail: (connectionId, region, vpcEndpointId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/vpc-endpoints/${encodeURIComponent(region)}/${encodeURIComponent(vpcEndpointId)}`,
  transitGateways: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/transit-gateways`,
  transitGatewayDetail: (connectionId, region, transitGatewayId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/transit-gateways/${encodeURIComponent(region)}/${encodeURIComponent(transitGatewayId)}`,
  vpnGateways: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/vpn-gateways`,
  vpnGatewayDetail: (connectionId, region, vpnGatewayId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/vpn-gateways/${encodeURIComponent(region)}/${encodeURIComponent(vpnGatewayId)}`,
  customerGateways: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/customer-gateways`,
  customerGatewayDetail: (connectionId, region, customerGatewayId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/customer-gateways/${encodeURIComponent(region)}/${encodeURIComponent(customerGatewayId)}`,
  vpnConnections: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/vpn-connections`,
  vpnConnectionDetail: (connectionId, region, vpnConnectionId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/vpn-connections/${encodeURIComponent(region)}/${encodeURIComponent(vpnConnectionId)}`,
  loadBalancers: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/load-balancers`,
  loadBalancerDetail: (connectionId, region, loadBalancerArn) =>
    `/compute/cloud-account-connections/${connectionId}/aws/load-balancers/${encodeURIComponent(region)}/${encodeURIComponent(loadBalancerArn)}`,
  targetGroups: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/target-groups`,
  targetGroupDetail: (connectionId, region, targetGroupArn) =>
    `/compute/cloud-account-connections/${connectionId}/aws/target-groups/${encodeURIComponent(region)}/${encodeURIComponent(targetGroupArn)}`,
  targetGroupRegisterTarget: (connectionId, region, targetGroupArn) =>
    `/compute/cloud-account-connections/${connectionId}/aws/target-groups/${encodeURIComponent(region)}/${encodeURIComponent(targetGroupArn)}/targets/register`,
  targetGroupDeregisterTarget: (connectionId, region, targetGroupArn) =>
    `/compute/cloud-account-connections/${connectionId}/aws/target-groups/${encodeURIComponent(region)}/${encodeURIComponent(targetGroupArn)}/targets/deregister`,
  listeners: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/listeners`,
  listenerDetail: (connectionId, region, listenerArn) =>
    `/compute/cloud-account-connections/${connectionId}/aws/listeners/${encodeURIComponent(region)}/${encodeURIComponent(listenerArn)}`,
  listenerRules: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/listener-rules`,
  listenerRuleDetail: (connectionId, region, ruleArn) =>
    `/compute/cloud-account-connections/${connectionId}/aws/listener-rules/${encodeURIComponent(region)}/${encodeURIComponent(ruleArn)}`,
  targetHealth: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/target-health`,
  targetHealthDetail: (connectionId, region, targetGroupArn) =>
    `/compute/cloud-account-connections/${connectionId}/aws/target-health/${encodeURIComponent(region)}/${encodeURIComponent(targetGroupArn)}`,
};
